import React from "react";

type LoaderSize = "sm" | "md" | "lg";

interface LoadingAnimationProps {
    size?: LoaderSize;
    className?: string;
    containerClassName?: string;

    ringColor?: string;
    dotAColor?: string;
    dotBColor?: string;
    speedMs?: number;
}

const sizeMap: Record<LoaderSize, string> = {
    sm: "w-16 h-16",
    md: "w-24 h-24",
    lg: "w-32 h-32",
};


const LoadingAnimation: React.FC<LoadingAnimationProps> = ({
                                                               size = "md",
                                                               className = "",
                                                               containerClassName = "",
                                                               ringColor = "#0027F9", // EON blue (default)
                                                               dotAColor = "#F9C32F", // EON yellow
                                                               dotBColor = "#0027F9", // EON blue
                                                               speedMs = 1200,
                                                           }) => {
    const dur = `${speedMs}ms`;

    return (
        <div className={`flex items-start ${containerClassName}`}>
            <svg viewBox="0 0 100 100" className={`${sizeMap[size]} ${className}`}>
                {/* Outer circle */}
                <circle
                    cx="50"
                    cy="50"
                    r="45"
                    fill="none"
                    stroke={ringColor}
                    strokeWidth="6"
                    strokeLinecap="round"
                    strokeDasharray="283"
                    strokeDashoffset="283"

                    style={{ transformOrigin: "50% 50%", animation: `spin ${dur} cubic-bezier(0.5,0.1,0.5,0.9) infinite` }}
                />

                {/* Rotating dots container */}
                <g
                    style={{
                        transformOrigin: "50% 50%",
                        animation: `spin ${dur} cubic-bezier(0.45,0,0.55,1) infinite`,
                    }}
                >
                    {/* Top dot (A) */}
                    <circle
                        cx="50"
                        cy="25"
                        r="6"
                        fill={dotAColor}
                        style={{ animation: `moveInOut ${dur} cubic-bezier(0.4,0,0.6,1) infinite` }}
                    />
                    {/* Bottom dot (A) */}
                    <circle
                        cx="50"
                        cy="75"
                        r="6"
                        fill={dotAColor}
                        style={{ animation: `moveOutIn ${dur} cubic-bezier(0.4,0,0.6,1) infinite` }}
                    />
                    {/* Right dot (B) */}
                    <circle
                        cx="75"
                        cy="50"
                        r="6"
                        fill={dotBColor}
                        style={{ animation: `moveLeftRight ${dur} cubic-bezier(0.4,0,0.6,1) infinite` }}
                    />
                    {/* Left dot (B) */}
                    <circle
                        cx="25"
                        cy="50"
                        r="6"
                        fill={dotBColor}
                        style={{ animation: `moveRightLeft ${dur} cubic-bezier(0.4,0,0.6,1) infinite` }}
                    />
                </g>


                <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          @keyframes moveInOut {
            0%, 100% { transform: translateY(0); }
            45%, 55% { transform: translateY(12.5px); }
          }
          @keyframes moveOutIn {
            0%, 100% { transform: translateY(0); }
            45%, 55% { transform: translateY(-12.5px); }
          }
          @keyframes moveLeftRight {
            0%, 100% { transform: translateX(0); }
            45%, 55% { transform: translateX(-12.5px); }
          }
          @keyframes moveRightLeft {
            0%, 100% { transform: translateX(0); }
            45%, 55% { transform: translateX(12.5px); }
          }
        `}</style>
            </svg>
        </div>
    );
};

export default LoadingAnimation;
